import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiPayInAlertService {
  private transactionStatusUrl = '/digitalpayments/core/transaction/status';

  constructor( private http: HttpClient ) { }

   /**
   * @description request to endpoint that handle the transaction status
   */
    getTransactionStatus(transactionId: string, token: string) {
      const headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'CheckoutAuthorization': token }) }

      const request = { token: token, transaction_id: transactionId }

      return this.http.post(`${environment.urlglobal_api}${this.transactionStatusUrl}`, request, headers).toPromise().catch(err => { throw err });
    }
  }
